import { CommitmentSourcesService } from '@festina/life-general-types/life/services/CommitmentSourcesService'
import { useFestinaMutation } from '@festina-life/authentication'

const method =
  CommitmentSourcesService.commitmentSourcesExternalPayloadsServicePutEdit

type Props = {
  ownerId: string
  tenantId: string
}

export const useEditCommitmentSourceExternalPayload = ({
  ownerId,
  tenantId,
}: Props) =>
  useFestinaMutation({
    component: 'life',
    isScenario: false,
    mutateFunction: async ({
      postingId,
      requestBody,
    }: Pick<Parameters<typeof method>[0], 'requestBody' | 'postingId'>) => {
      await method({
        ownerId,
        xTenantId: tenantId,
        postingId,
        requestBody,
      })
    },
    roles:
      CommitmentSourcesService.commitmentSourcesExternalPayloadsServicePutEdit_roles,
  })
